/** WCAG relative luminance for opaque sRGB colors. */
export const contrastRatio = (
  foreground: string,
  background: string,
): number => {
  const luminance = (hex: string) => {
    const channels = hex.replace("#", "").match(/.{2}/g);
    if (!channels || channels.length !== 3)
      throw new Error(`Expected six-digit hex color: ${hex}`);
    const [r, g, b] = channels.map((channel) => {
      const value = parseInt(channel, 16) / 255;
      return value <= 0.04045
        ? value / 12.92
        : ((value + 0.055) / 1.055) ** 2.4;
    });
    return r * 0.2126 + g * 0.7152 + b * 0.0722;
  };
  const a = luminance(foreground);
  const b = luminance(background);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
};

/** Pick a readable foreground for colored fills, independent of theme mode. */
export const readableForeground = (background: string): string =>
  contrastRatio("#FFFFFF", background) >= contrastRatio("#000000", background)
    ? "#FFFFFF"
    : "#000000";
